<nz-content>
  <main class="inner-content">
    <router-outlet></router-outlet>
  </main>
</nz-content>
